var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrangeUserName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 8C13.7154 8 11.8469 9.86847 11.8469 12.1542C11.8469 14.4399 13.7154 16.3084 16.0011 16.3084C18.2868 16.3084 20.1553 14.4399 20.1553 12.1542C20.1553 9.86847 18.2868 8 16.0011 8ZM23.1304 19.6281C23.0215 19.356 22.8764 19.102 22.7132 18.8662C21.8787 17.6326 20.5907 16.8163 19.1395 16.6168C18.9581 16.5986 18.7585 16.6349 18.6134 16.7438C17.8515 17.3061 16.9445 17.5964 16.0011 17.5964C15.0578 17.5964 14.1508 17.3061 13.3889 16.7438C13.2437 16.6349 13.0442 16.5805 12.8628 16.6168C11.4116 16.8163 10.1054 17.6326 9.28913 18.8662C9.12587 19.102 8.98073 19.3742 8.87191 19.6281C8.8175 19.737 8.83562 19.864 8.89003 19.9728C9.03517 20.2268 9.21656 20.4808 9.37982 20.6984C9.63378 21.0431 9.9059 21.3515 10.2143 21.6417C10.4683 21.8957 10.7585 22.1315 11.0488 22.3674C12.4819 23.4377 14.2052 24 15.983 24C17.7608 24 19.4842 23.4376 20.9173 22.3674C21.2075 22.1497 21.4977 21.8957 21.7517 21.6417C22.042 21.3515 22.3322 21.0431 22.5862 20.6984C22.7676 20.4626 22.9309 20.2268 23.076 19.9728C23.1667 19.864 23.1848 19.7369 23.1304 19.6281Z",
    fill: "#E1591F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E3E3E3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrangeUserName);
export default __webpack_public_path__ + "static/media/icon-orange-user-name.924c17304d969b4eb6fd343f6fab0a8d.svg";
export { ForwardRef as ReactComponent };